import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';

const ContentNav = ({ className, links, matchChildren, matchQuery }) => (
    <div
        className={cx('flex border-2 border-gray-light rounded overflow-hidden w-full', className)}
    >
        {links.map(({ label, href }, i) => (
            <NavLink
                to={href}
                key={href}
                className={cx(
                    'flex-1 p-4 text-center uppercase font-bold text-xs tracking-wide text-gray-light hover:text-gray-base border-gray-light',
                    { 'border-l-2': i !== 0 }
                )}
                activeClassName="bg-gray-lighter text-gray-base"
                exact={false}
                isActive={(_, location) => {
                    const x = matchQuery ? href : href.split('?')[0];
                    const y = matchQuery ? location.pathname : location.pathname.split('?')[0];
                    return matchChildren ? x.includes(y) : x === y;
                }}
            >
                {label}
            </NavLink>
        ))}
    </div>
);

ContentNav.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            href: PropTypes.string.isRequired,
        })
    ).isRequired,
    className: PropTypes.string,
    matchChildren: PropTypes.bool,
    matchQuery: PropTypes.bool,
};

ContentNav.defaultProps = {
    className: '',
    matchChildren: true,
    matchQuery: false,
};

export default ContentNav;
